import React from 'react';
import styled from 'styled-components';
import SVG, {Props as SVGProps} from 'react-inlinesvg';

import addGuest from '../../../assets/icons/add-guest.svg';
import avatarAccountIcon from '../../../assets/icons/avatarAccountIcon.svg';
import accountMenuKey from '../../../assets/icons/accountMenuKey.svg';
import accountMenuBookings from '../../../assets/icons/accountMenuBookings.svg';
import accountMenuStar from '../../../assets/icons/accountMenuStar.svg';
import accountMenuAccount from '../../../assets/icons/accountMenuAccount.svg';
import accountMenuHome from '../../../assets/icons/accountMenuHome.svg';
import arrowNext from '../../../assets/icons/arrowNext.svg';
import backArrow from '../../../assets/icons/back-arrow.svg';
import blackArrowIcon from '../../../assets/icons/blackArrowIcon.svg';
import whiteArrowIcon from '../../../assets/icons/whiteArrowIcon.svg';
import webcam from '../../../assets/icons/webcam.svg';
import mapnemu from '../../../assets/icons/map-menu.svg';
import smallClockIcon from '../../../assets/icons/smallClockIcon.svg';
import smallGuestIcon from '../../../assets/icons/smallGuestIcon.svg';
import share from '../../../assets/icons/share.svg';
import shareLink from '../../../assets/icons/shareLink.svg';
import shareFinishLater from '../../../assets/icons/shareFinishLater.svg';
import shareGuests from '../../../assets/icons/shareGuests.svg';
import successIcon from '../../../assets/icons/successIcon.svg';
import payment from '../../../assets/icons/payment.svg';
import editguest from '../../../assets/icons/edit-guest-icon.svg';
import removeguest from '../../../assets/icons/remove-guest-icon.svg';
import dateIcon from '../../../assets/icons/dates-icon.svg';
import guestsIcon from '../../../assets/icons/guests-icon.svg';
import displayArrowIcon from '../../../assets/icons/display-blue-icn.svg';
import magnifierIcon from '../../../assets/icons/magnifier.svg';
import mapMark from '../../../assets/icons/mapMark.svg';
import menuVeridicationIcon from '../../../assets/icons/menuVeridicationIcon.svg';
import menuNotificationsIcon from '../../../assets/icons/menuNotificationsIcon.svg';
import menuPaymentsIcon from '../../../assets/icons/menuPaymentsIcon.svg';
import menuSecurityIcon from '../../../assets/icons/menuSecurityIcon.svg';
import menuPersonalIcon from '../../../assets/icons/menuPersonalIcon.svg';
import paymentMastercard from '../../../assets/icons/paymentMastercard.svg';
import paymentVisa from '../../../assets/icons/paymentVisa.svg';
import closeIcon from '../../../assets/icons/close-icon.svg';
import calendarIcon from '../../../assets/icons/calendar-icon.svg';
import shoppingBagIcon from '../../../assets/icons/shoppingBagIcon.svg';
import circleLanguageIcon from '../../../assets/icons/circleLanguageIcon.svg';
import circlePeopleIcon from '../../../assets/icons/circlePeopleIcon.svg';
import circleTimeIcon from '../../../assets/icons/circleTimeIcon.svg';
import circleGlassIcon from '../../../assets/icons/circleGlassIcon.svg';
import likeIcon from '../../../assets/icons/likeIcon.svg';
import locationIcon from '../../../assets/icons/locationIcon.svg';
import shareIcon from '../../../assets/icons/shareIcon.svg';
import includedHealth from '../../../assets/icons/includedHealth.svg';
import includedTicket from '../../../assets/icons/includedTicket.svg';
import includedDrinks from '../../../assets/icons/includedDrinks.svg';
import includedFood from '../../../assets/icons/includedFood.svg';

const icons: any = {
  addGuest,
  avatarAccountIcon,
  accountMenuKey,
  accountMenuBookings,
  accountMenuStar,
  accountMenuAccount,
  accountMenuHome,
  arrowNext,
  backArrow,
  blackArrowIcon,
  webcam,
  mapnemu,
  share,
  shareLink,
  shareFinishLater,
  shareGuests,
  successIcon,
  shoppingBagIcon,
  smallClockIcon,
  smallGuestIcon,
  payment,
  editguest,
  removeguest,
  dateIcon,
  includedHealth,
  includedTicket,
  includedDrinks,
  includedFood,
  guestsIcon,
  displayArrowIcon,
  magnifierIcon,
  mapMark,
  menuVeridicationIcon,
  menuNotificationsIcon,
  menuPaymentsIcon,
  menuSecurityIcon,
  menuPersonalIcon,
  paymentMastercard,
  paymentVisa,
  whiteArrowIcon,
  closeIcon,
  calendarIcon,
  circleLanguageIcon,
  circlePeopleIcon,
  circleTimeIcon,
  circleGlassIcon,
  likeIcon,
  locationIcon,
  shareIcon,
};

export type IconProps = {
  name: string | any;
  title?: string;
  className?: string;
  size?: string | number;
  transform?: string | number;
  color?: string;
} & React.HTMLAttributes<SVGElement> &
  React.HTMLAttributes<SVGProps>;

const StyledSVGIcon = styled(SVG)<{
  src: any;
  color?: string;
  size?: string | number;
}>`
  width: ${props => props.size || '24px'};
  height: ${props => props.size || '24px'};
  fill: ${props => props.color || 'none'};
  color: ${props => props.color || 'none'};
  path {
    fill: ${props => props.color || 'currentColor'};
  }
`;

const StyledIcon = (props: IconProps) => {
  return (
    <StyledSVGIcon
      src={icons[props.name]}
      size={props.size}
      title={props.title || props.name}
      color={props.color}
      className={props.className}
    />
  );
};

export default StyledIcon;
export {
  addGuest,
  avatarAccountIcon,
  accountMenuKey,
  accountMenuBookings,
  accountMenuStar,
  accountMenuAccount,
  accountMenuHome,
  arrowNext,
  backArrow,
  blackArrowIcon,
  webcam,
  mapnemu,
  share,
  shareLink,
  shareFinishLater,
  shareGuests,
  successIcon,
  shoppingBagIcon,
  smallClockIcon,
  smallGuestIcon,
  payment,
  editguest,
  removeguest,
  dateIcon,
  guestsIcon,
  includedHealth,
  includedTicket,
  includedDrinks,
  includedFood,
  displayArrowIcon,
  magnifierIcon,
  mapMark,
  menuVeridicationIcon,
  menuNotificationsIcon,
  menuPaymentsIcon,
  menuSecurityIcon,
  menuPersonalIcon,
  paymentMastercard,
  paymentVisa,
  whiteArrowIcon,
  closeIcon,
  calendarIcon,
  circleLanguageIcon,
  circlePeopleIcon,
  circleTimeIcon,
  circleGlassIcon,
  likeIcon,
  locationIcon,
  shareIcon,
};
